'use strict';

frontendApp.factory('LayerService', ['$rootScope', '$log', '$timeout', 'StateService', function ($rootScope, $log, $timeout, StateService) {

  var _service = {
    layer: {
      current: 'main',
      stack: ['main']
    }
  };

  $rootScope.currentLayer = _service.layer.current;

  _service.LAYERS = {
    MAIN: 'main',
    SEARCH: 'search',
    RESOURCE: 'resource'
  };

  _service.EVENTS = {
    SHOW_MAIN: 'LayerService.show_' + _service.LAYERS.MAIN,
    HIDE_MAIN: 'LayerService.hide_' + _service.LAYERS.MAIN,
    SHOW_SEARCH: 'LayerService.show_' + _service.LAYERS.SEARCH,
    HIDE_SEARCH: 'LayerService.hide_' + _service.LAYERS.SEARCH,
    SHOW_RESOURCE: 'LayerService.show_' + _service.LAYERS.RESOURCE,
    HIDE_RESOURCE: 'LayerService.hide_' + +_service.LAYERS.RESOURCE,
    CURRENT: 'LayerService.current'
  };

  $rootScope.$on(EVENTS.LOGIN_REQUIRED, function () {
    _service.pushLayer('main');
  });

  $rootScope.$on(EVENTS.LOGIN_CONFIRMED, function () {
    _service.popLayer();
  });

  _service.pushLayer = function (layer) {

    // we don't want the same layer pushed twice
    if (layer != _.last(_service.layer.stack)) {
      _service.layer.stack.push(layer);
      _service.layer.current = $rootScope.currentLayer = _.last(_service.layer.stack);
      $rootScope.$broadcast('LayerService.show_' + layer);
      console.log('pushLayer:', _service.layer);
    }

    $rootScope.$broadcast(_service.EVENTS.CURRENT, _service.layer.current);

    // No clue why I need this but I do
    $timeout(function () {
      $rootScope.$apply();
    });
  };

  _service.popLayer = function (layer) {

    // We can't pop off the bottom-most 'main' layer
    if (_service.layer.stack.length > 1) {
      var popped = _service.layer.stack.pop();
      _service.layer.current = $rootScope.currentLayer = _.last(_service.layer.stack);

      $rootScope.$broadcast('LayerService.hide_' + popped);
      console.log('popLayer:', _service.layer);
    }

    $rootScope.$broadcast(_service.EVENTS.CURRENT, _service.layer.current);

    // No clue why I need this but I do
    $timeout(function () {
      $rootScope.$apply();
    });
  };

  _service.popToMain = function () {
    //_service.layer.stack.length = 1;
    while (_service.layer.stack.length > 1) {
      _service.popLayer();
    }

    _service.layer.current = $rootScope.currentLayer = _.last(_service.layer.stack);

    $rootScope.$broadcast(_service.EVENTS.CURRENT, _service.layer.current);

    // No clue why I need this but I do
    $timeout(function () {
      $rootScope.$apply();
    });
  };

  _service.getTopLayer = function () {
    return _.last(_service.layer.stack);
  }

  _service.getLayer = function () {
    return _service.layer;
  };

  return _service;
}]);

